var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCelery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3225_12264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.62876 6.81485e-06C2.25048 -0.000817135 1.87577 0.0730816 1.52613 0.21746C1.17649 0.361839 0.858817 0.573855 0.591336 0.841336C0.323855 1.10882 0.111839 1.42649 -0.0325396 1.77613C-0.176918 2.12577 -0.250817 2.50048 -0.249993 2.87876V27.1213C-0.250817 27.4995 -0.176918 27.8742 -0.0325396 28.2239C0.111839 28.5735 0.323855 28.8912 0.591336 29.1587C0.858817 29.4262 1.17649 29.6382 1.52613 29.7826C1.87577 29.9269 2.25048 30.0008 2.62876 30H26.8713C27.2495 30.0008 27.6242 29.9269 27.9739 29.7826C28.3235 29.6382 28.6412 29.4262 28.9087 29.1587C29.1762 28.8912 29.3882 28.5735 29.5326 28.2239C29.6769 27.8742 29.7508 27.4995 29.75 27.1213V2.87876C29.7508 2.50048 29.6769 2.12577 29.5326 1.77613C29.3882 1.42649 29.1762 1.10882 28.9087 0.841336C28.6412 0.573855 28.3235 0.361839 27.9739 0.21746C27.6242 0.0730816 27.2495 -0.000817135 26.8713 6.81485e-06H2.62876ZM12.85 3.84001C17.9725 3.84001 21.635 5.63751 22.45 6.04501L20.9575 9.23251C17.905 7.91126 14.7163 7.47001 13.8675 7.47001C11.9 7.47001 11.155 8.62251 11.155 9.67376V20.2913C11.155 21.3775 11.9 22.53 13.8675 22.53C14.7163 22.53 17.905 22.055 20.9575 20.7675L22.45 23.8875C21.9063 24.2263 17.9038 26.16 12.85 26.16C11.46 26.16 7.05001 25.855 7.05001 20.36V9.64126C7.05001 4.14501 11.46 3.84001 12.85 3.84001Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3225_12264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCelery);
export default __webpack_public_path__ + "static/media/celery.2b662b48fbabf4fdde30676f9ab48897.svg";
export { ForwardRef as ReactComponent };